import { createInstance, type Resource } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

export const SUPPORTED_LANGUAGES = ['ru', 'kk', 'en'] as const;
export type Language = (typeof SUPPORTED_LANGUAGES)[number];

const localeFiles = import.meta.glob<Record<string, unknown>>(['./locales/*/*.json', '!./locales/*/dev.json'], {
    eager: true,
    import: 'default',
});

const resources: Resource = {};
for (const [path, translations] of Object.entries(localeFiles)) {
    const [, language, namespace] = /\.\/locales\/([^/]+)\/([^/]+)\.json$/.exec(path) ?? [];
    if (!language || !namespace) continue;
    resources[language] = { ...resources[language], [namespace]: translations };
}

export const i18n = createInstance();

void i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        supportedLngs: [...SUPPORTED_LANGUAGES],
        load: 'languageOnly',
        fallbackLng: 'ru',
        defaultNS: 'common',
        interpolation: { escapeValue: false },
        detection: { order: ['localStorage', 'navigator'], lookupLocalStorage: 'i18nextLng', caches: ['localStorage'] },
    });

const syncDocumentLanguage = (language: string) => {
    document.documentElement.lang = language;
};
syncDocumentLanguage(i18n.resolvedLanguage ?? 'ru');
i18n.on('languageChanged', syncDocumentLanguage);
